/* Fix responsive pagina "Cosa rende i nostri tappeti unici" */
(function() {
  function fixCards() {
    var w = window.innerWidth;
    var cards = document.querySelectorAll('.grid__item-inner.grid__item-inner--image');
    var wrappers = document.querySelectorAll('a.d-block.image-content__image-wrapper');

    if (w <= 961) {
      /* Mobile: card compatte */
      wrappers.forEach(function(el) {
        el.style.setProperty('padding-top', '0', 'important');
        el.style.setProperty('position', 'relative', 'important');
        el.style.setProperty('height', '90px', 'important');
      });
      cards.forEach(function(card) {
        card.style.setProperty('height', 'auto', 'important');
        card.style.setProperty('padding-top', '20px', 'important');
        card.style.setProperty('padding-bottom', '20px', 'important');
      });
    } else if (w <= 1300) {
      /* Tablet/piccolo desktop: icona fissa + altezza uguale */
      wrappers.forEach(function(el) {
        el.style.setProperty('padding-top', '0', 'important');
        el.style.setProperty('position', 'relative', 'important');
        el.style.setProperty('height', '90px', 'important');
      });
      cards.forEach(function(card) {
        card.style.setProperty('height', 'auto', 'important');
        card.style.removeProperty('padding-top');
        card.style.removeProperty('padding-bottom');
      });
      var maxH = 0;
      cards.forEach(function(card) {
        var h = card.getBoundingClientRect().height;
        if (h > maxH) maxH = h;
      });
      if (maxH > 0) {
        cards.forEach(function(card) {
          card.style.setProperty('height', maxH + 'px', 'important');
        });
      }
    } else {
      /* Desktop grande: torna al CSS originale */
      cards.forEach(function(card) {
        card.style.removeProperty('height');
        card.style.removeProperty('padding-top');
        card.style.removeProperty('padding-bottom');
      });
      wrappers.forEach(function(el) {
        el.style.removeProperty('padding-top');
        el.style.removeProperty('position');
        el.style.removeProperty('height');
      });
    }
  }

  /* Fix sezione "Cosa rende i nostri tappeti unici" — reorder icone/immagini su mobile */
  function fixIconImageOrder() {
    var w = window.innerWidth;
    if (w > 991) return;

    /* Trova tutte le .row dentro advanced-content sections */
    document.querySelectorAll('.section-block > .row').forEach(function(row) {
      var children = row.children;
      if (children.length !== 8) return; /* Solo la sezione con 8 blocchi (4 icone + 4 immagini) */

      /* Blocco 3 (immagine impermeabile) e 4 (icona impermeabile): invertire */
      children[2].style.setProperty('order', '4');
      children[3].style.setProperty('order', '3');
      /* Blocco 7 (immagine pet friendly) e 8 (icona pet friendly): invertire */
      children[6].style.setProperty('order', '8');
      children[7].style.setProperty('order', '7');

      row.style.setProperty('display', 'flex');
      row.style.setProperty('flex-wrap', 'wrap');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { fixCards(); fixIconImageOrder(); });
  } else {
    fixCards();
    fixIconImageOrder();
  }
  window.addEventListener('resize', function() { fixCards(); fixIconImageOrder(); });
})();
